module.exports = __webpack_public_path__ + "img/cc_image.5d0facfb.png";